import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { SunSpinner } from '@sunrun/component-library';
import { HouseWithCircle } from '@sunrun/component-library/illustrations';

const StyledLoader = styled.div`
  z-index: 101; // 1 higher than the sidebar navigation
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 26, 60, ${props => props.opacity});

  p,
  h1 {
    margin-top: 20px;
    text-align: center;
    font-family: Roobert, sans-serif;
    letter-spacing: 3px;
    color: white;
  }

  .copy {
    text-transform: uppercase;
  }
`;

const FullScreenLoading = ({ copy, illustration, opacity, subtext, success, title }) => (
  <StyledLoader data-testid="full-screen-loader" opacity={opacity}>
    <div>
      {illustration === 'sun' && <SunSpinner sunSize="5" raySize="0.75" sunglasses={success} />}
      {illustration === 'sun' && title && <h1>{title}</h1>}
      {illustration === 'sun' && subtext && <p>{subtext}</p>}
      {illustration === 'sun' && copy && <p className="copy">{copy}</p>}
      {illustration === 'house' && <HouseWithCircle copy={copy} />}
    </div>
  </StyledLoader>
);

FullScreenLoading.propTypes = {
  copy: PropTypes.string,
  illustration: PropTypes.string,
  opacity: PropTypes.number,
  subtext: PropTypes.string,
  success: PropTypes.bool,
  title: PropTypes.string,
};

FullScreenLoading.defaultProps = {
  copy: '',
  illustration: 'sun',
  opacity: 0.9,
  subtext: '',
  success: null,
  title: '',
};

export default FullScreenLoading;
